/**
 * Ensure user record exists in public.users table
 * This handles cases where auth users exist but don't have corresponding records
 */

import { supabase } from './supabase-auth'

export async function ensureUserRecord(authUser: any): Promise<boolean> {
  try {
    // Check if user record exists
    const { data: existingUser, error: checkError } = await supabase
      .from('users')
      .select('id')
      .eq('id', authUser.id)
      .single()

    if (existingUser) {
      // User already exists
      return true
    }

    // Create user record if it doesn't exist
    const { data: orgs } = await supabase
      .from('organizations')
      .select('id')
      .eq('name', 'PCM Financial')
      .single()

    const defaultOrgId = orgs?.id || null

    // Determine role based on email domain
    const email = authUser.email || ''
    const isStaffEmail = email.endsWith('@pcmfinancial.ca')
    const role = isStaffEmail ? 'pcm_staff' : 'client_user'

    // Extract name from email if not provided
    const fullName = authUser.user_metadata?.full_name || 
                    authUser.user_metadata?.name || 
                    email.split('@')[0].replace(/[._]/g, ' ').replace(/\b\w/g, l => l.toUpperCase())

    // Create the user record
    const { error: insertError } = await supabase
      .from('users')
      .insert({
        id: authUser.id,
        organization_id: defaultOrgId,
        role: role,
        full_name: fullName,
        avatar_url: authUser.user_metadata?.avatar_url || null,
        phone: authUser.user_metadata?.phone || null,
        two_factor_enabled: false, // Start with MFA disabled
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      })

    if (insertError) {
      console.error('Failed to create user record:', insertError)
      return false
    }

    console.log('Created missing user record for:', email)
    return true
  } catch (error) {
    console.error('Error ensuring user record:', error)
    return false
  }
}